// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__PVN_R","breadcrumbLink":"Breadcrumbs_breadcrumbLink__6fA4G","currentPage":"Breadcrumbs_currentPage___bLNM"};